import { render, staticRenderFns } from "./LmOnboardingSteps.vue?vue&type=template&id=6f605b2a&scoped=true"
import script from "./LmOnboardingSteps.vue?vue&type=script&lang=js"
export * from "./LmOnboardingSteps.vue?vue&type=script&lang=js"
import style0 from "./LmOnboardingSteps.vue?vue&type=style&index=0&id=6f605b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f605b2a",
  null
  
)

export default component.exports